import * as graphql from 'generated/graphql';

import OpenQuestionDisplay from './OpenQuestionDisplay';
import ReviewGoalsDisplay from './ReviewGoalsDisplay';
import SentimentDisplay from './SentimentDisplay';
import StarsDisplay from './StarsDisplay';

export default function EvaluationSubmissionItemDisplay(props: {
	form: graphql.EvaluationSectionItem;
	item: graphql.EvaluationSubmissionItem;
	metadata?: { goal: graphql.EvaluationSubmissionGoal };
}) {
	if (props.item.type === graphql.EvaluationSectionItemType.OpenQuestion) {
		return <OpenQuestionDisplay item={props.item} />;
	}

	if (props.item.type === graphql.EvaluationSectionItemType.Sentiment) {
		return <SentimentDisplay item={props.item} />;
	}

	if (props.item.type === graphql.EvaluationSectionItemType.Stars) {
		return <StarsDisplay item={props.item} />;
	}

	if (props.item.type === graphql.EvaluationSectionItemType.ReviewGoals) {
		return <ReviewGoalsDisplay form={props.form} item={props.item} metadata={props.metadata!} />;
	}

	return <>{`Unknown type: ${props.item.type}.`}</>;
}
